import classNames from 'classnames';
import React from 'react';
import './index.less';

interface ITeamLogo {
    size: 'large' | 'medium' | 'small';
    /** 团队logo */
    src?: string;
    /** 团队名字 */
    name: string;
    /** 灰色处理 */
    grayscale?: boolean;
    /** 团队id */
    oid?: number;
}

/**
 * 团队 logo
 */
const TeamLogo: React.FC<ITeamLogo> = ({ size, src, name, grayscale, oid }) => {
    return (
        <div
            className={classNames('Widget', `teamLogo`, {
                grayscale,
                'user-avatar': !oid,
            })}
            data-has-border={!!oid && !!src}
        >
            {src ? (
                <img src={src} className={classNames('img', size)} />
            ) : (
                <div className={classNames('name', size)}>{name.substring(0, 1)}</div>
            )}
        </div>
    );
};

export default React.memo(TeamLogo);
